'use strict';

var React = require('react');

var SvgListFilledMajor = function SvgListFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4a1 1 0 0 0 0 2h8.5a1 1 0 1 0 0-2h-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10a1 1 0 0 1 1-1h8.5a1 1 0 1 1 0 2h-8.5a1 1 0 0 1-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14a1 1 0 1 0 0 2h8.5a1 1 0 1 0 0-2h-8.5Z"
  }));
};
SvgListFilledMajor.displayName = "ListFilledMajor";

exports.SvgListFilledMajor = SvgListFilledMajor;
